/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { gs } from '../utils';
// TODO type this more strictly so it's either got an icon, or it has a url and a tooltip
export var Icon = function (_a) {
    var url = _a.url, icon = _a.icon;
    return icon ? (jsx(React.Fragment, null, icon)) : (jsx("img", { css: { height: gs(2), width: gs(2) }, src: url }));
};
//# sourceMappingURL=Icon.js.map